import { VNM_STANDARD_PLAN_TEMPLATE_ID } from 'domain/plans';

export const nonEmpty = <T>(value: T): value is NonNullable<T> =>
  value !== null && value !== undefined;

type QueriedPlanTemplate = GetPlanTemplateInfoQuery['planTemplates'][number];

interface Props {
  oldPlanTemplateId?: number | null;
  availablePlanTemplates: QueriedPlanTemplate[];
}

export const chooseMovingPlanTemplate = ({
  oldPlanTemplateId,
  availablePlanTemplates,
}: Props): QueriedPlanTemplate | undefined => {
  const templates = availablePlanTemplates.filter(nonEmpty);
  if (!templates.length) return undefined;

  const findPlanTemplate = (id: number) =>
    templates.find(template => template.id === id);
  // try to keep movers on existing experience
  const oldPlanTemplate =
    oldPlanTemplateId && findPlanTemplate(oldPlanTemplateId);
  // prioritize ACB over UCB
  const ACBVNMPlanTemplate = findPlanTemplate(VNM_STANDARD_PLAN_TEMPLATE_ID);

  return oldPlanTemplate || ACBVNMPlanTemplate || templates[0];
};
